import React from 'react';
import {makeStyles} from '@material-ui/core/styles';

//material-ui core
import {Drawer, Button, Box, Divider, Typography} from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Grid from '@material-ui/core/Grid';
import Slide from '@material-ui/core/Slide';
import Fade from '@material-ui/core/Fade';

//material-ui Icons
import ExpandLessRoundedIcon from '@material-ui/icons/ExpandLessRounded';
import ApartmentIcon from '@material-ui/icons/Apartment';
import RestaurantIcon from '@material-ui/icons/Restaurant';
import SportsEsportsIcon from '@material-ui/icons/SportsEsports';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';

import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded';
import ClearRoundedIcon from '@material-ui/icons/ClearRounded';

//import others
import DrawersMobile from '../Drawers/DrawersMobile';
import FacebookProgress from './FacebookProgress';
import {grey} from '@material-ui/core/colors';
import Image from 'material-ui-image/lib/components/Image/Image';
import logo from '../../../assets/img/kabupaten.png';
import SearchMobileDetails from './SearchMobileDetails';
import MaskedInput from 'react-text-mask';

const useStyles = makeStyles((theme) => ({
  //search
  root_search: {
    padding: '2px 4px',
    top: 10,
    left: 10,
    display: 'flex',
    alignItems: 'center',
    width: '94.7vw',
    position: 'relative',
    borderRadius: 9,
  },
  input: {
    marginLeft: theme.spacing(1),
    width: '100%',
    // flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
  },
  drawer: {
    flexDirection: 'unset',
  },

  //details
  details: {
    width: '94.7vw',
    marginLeft: 10,
    display: 'flex',
    background: 'white',
    padding: '13px 0px 10px 0px',
    borderRadius: '0px 0px 10px 10px',
    fontSize: 15,
  },
  detailsNone: {
    display: 'none',
  },
  detailsContent: {
    paddingTop: 5,
    display: 'flex',
    color: '#7e8a96',
    width: '100%',
    textDecoration: 'none',
    '&:hover': {
      color: 'black',
    },
  },
  detailsIcon: {
    width: 56,
    textAlign: 'center',
  },
  detailsExpand: {
    backgroundColor: '#fafafa',
    height: '100vh',
    width: '100vw',
    boxShadow: '0px -3px 20px 2px rgba(0,0,0,0.12)',
    position: 'absolute',
    top: 0,
    zIndex: -1,
  },
  detailsPajak: {
    marginTop: 30,
    backgroundColor: 'white',
    fontWeight: 'bold',
    borderRadius: 0,
    padding: 30,
  },
  detailsText: {
    color: 'black',
    paddingBottom: 10,
    textAlign: 'center',
  },
  detailsButton: {
    textTransform: 'Capitalize',
    marginTop: 10,
    marginBottom: 10,
  },
  detailsHide: {
    width: '100vw',
    textAlign: 'center',
    position: 'absolute',
    bottom: 20,
    // left: 100,
  },
  detailsHideButton: {
    borderRadius: 13,
    fontWeight: 'bold',
    // textTransform: 'Lowercase',
  },
  divImg: {
    paddingTop: 90,
  },
}));

const TextMaskCustom = (props) => {
  const {inputRef, ...other} = props;
  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      // kd_prov.kd_kabupaten.kd_kec.kd_kel.kd_blok.no_urut.kd_jns
      mask={[
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
      ]}
      placeholderChar={'_'}
    />
  );
};

const SearchMobile = (props) => {
  const classes = useStyles();
  const {
    setDrawer,
    inputNop,
    setInputNop,
    facebookProgress,
    clearIcon,
    handleKeyPress,
    onClear,
    onSearchNop,
    checked,
    handleDetails,
    searchNop,
    searchSppt,
    piutangLoading,
    tahunSPPT,
    handleTahunSPPT,
    itemTahunSPPT,
    detailNop,
    detailSppt,
    images,
    streetView,
  } = props;

  return (
    <div>
      {/* search */}
      <div>
        <Paper component="div" className={classes.root_search}>
          <Tooltip title="Menu" arrow>
            <IconButton className={classes.iconButton} aria-label="menu" onClick={() => setDrawer(true)}>
              <MenuIcon />
            </IconButton>
          </Tooltip>

          <InputBase
            value={inputNop}
            onChange={(e) => setInputNop(e.target.value)}
            className={classes.input}
            placeholder="Search NOP"
            inputComponent={TextMaskCustom}
            onKeyDown={handleKeyPress}
          />

          {/* Loading Facebook */}
          {facebookProgress ? <FacebookProgress /> : null}

          {/* Clear Icon After Loading */}
          {clearIcon ? (
            <Tooltip title="Clear" arrow>
              <IconButton type="button" className={classes.iconButton} onClick={onClear} aria-label="close">
                <ClearRoundedIcon />
              </IconButton>
            </Tooltip>
          ) : null}

          <Divider className={classes.divider} orientation="vertical" />
          <Tooltip title="Search" arrow>
            <IconButton
              type="button"
              className={classes.iconButton}
              onClick={() => onSearchNop(inputNop)}
              // onClick={onSearchNop}
              aria-label="search">
              <SearchIcon />
            </IconButton>
          </Tooltip>
        </Paper>

        <Box className={!checked ? classes.details : classes.detailsNone} boxShadow={3} onClick={handleDetails}>
          <div className={classes.detailsContent}>
            <div className={classes.detailsIcon}>
              <ExpandMoreRoundedIcon />
            </div>
            Show More
          </div>
        </Box>
      </div>

      {/*    Expand   */}
      <Slide in={checked}>
        <div className={classes.detailsExpand}>
          <SearchMobileDetails
            checked={checked}
            handleDetails={handleDetails}
            searchNop={searchNop}
            searchSppt={searchSppt}
            piutangLoading={piutangLoading}
            tahunSPPT={tahunSPPT}
            handleTahunSPPT={handleTahunSPPT}
            itemTahunSPPT={itemTahunSPPT}
            detailNop={detailNop}
            detailSppt={detailSppt}
            images={images}
            streetView={streetView}
          />
        </div>
      </Slide>
    </div>
  );
};

export default SearchMobile;
